<!-- Predefined Category -->

<ng-container *ngIf="componentData.currentIdeationStep == currentIdeationStepEnum.category || componentData.currentIdeationStep == currentIdeationStepEnum.custom_category">
  <app-ai-extra-information-input [inputs]="conceptInputs" (additionalContextChange)="conceptAdditionalContext = $event"></app-ai-extra-information-input>
<!-- {{componentData.selectedCategories | json}} -->
</ng-container>
<!-- Predefined Category -->


<!-- Action Buttons -->
<ng-container *ngIf="componentData.currentIdeationStep == currentIdeationStepEnum.custom_category || componentData.currentIdeationStep == currentIdeationStepEnum.category">
  <div class="d-flex justify-content-between gap-3 mt-4">
    <button *ngIf="componentData.currentIdeationStep == currentIdeationStepEnum.category" (click)="exitTheGenerator()" class="btn btn-light d-flex flex-center me-3">Back</button>
    <app-dynamic-ai-button (buttonClick)="startThinking()" buttonLabel="Start Ideation" [buttonSettings]="{ colorSet: 'primary' }"></app-dynamic-ai-button>
  </div>
</ng-container>
<!-- Action Buttons -->

<!-- Results -->
<div class="card h-100 d-flex flex-column p-4 h-100 mh-100" *ngIf="componentData.currentIdeationStep == currentIdeationStepEnum.results">
  <div class="mb-5 card-head">
    <h4 class="text-gray-700">Let's do it! <span class="fs-1">😉</span></h4>
    <div *ngIf="componentData.selectedCategories.length">
      <span *ngFor="let category of componentData.selectedCategories" class="badge badge-sm badge-primary me-2 mb-2">{{ category.label }}</span>
    </div>
  </div>
  <div class="card-body rounded-3 card-scroll flex-grow-1 p-5 bg-light" id="resultsScrollContainer" *ngIf="componentData.results.length">
    <div class="ideas-container p-3 rounded d-flex flex-column gap-2 min-h-100">
      <ng-container *ngFor="let result of componentData.results; let i = index">
        <div
        *ngIf="!result?.processing"
          id="title-result-{{ i }}"
          (click)="onSelectResult(i)"
          [ngClass]="{
            'bg-light-primary border-primary shadow-sm': componentData.selectedResultIndex == i,
            'bg-white bg-hover-light-primary bg-opacity-100': componentData.selectedResultIndex != i,
            'inactive-result': componentData.selectedResultIndex != i && componentData.selectedResultIndex != null,
            'fake-disabled': !!result.writing
          }"
          class="idea-item py-2 px-2 text-gray-800 border border-1 rounded"
        >
          <div *ngIf="!!result?.category?.length" class="badge badge-lg badge-light-primary mb-2 mw-100 text-truncate">
            {{ result.category }}
            <app-ai-cursor *ngIf="result.writing == 'category'"></app-ai-cursor>
          </div>
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <div class="form-check form-check-custom">
                <input
                  class="form-check-input border-primary"
                  type="radio"
                  [checked]="componentData.selectedResultIndex == i"
                  id="title{{ i }}"
                />
                <label class="form-check-label flex-grow-1" for="title{{ i }}">
                  <span class="form-control form-control-flush bg-white rounded fw-bold fs-6 text-nowrap" *ngIf="result.writing == 'title' || result.writing == 'category'">
                    {{ result.value }}<app-ai-cursor></app-ai-cursor>
                  </span>
                  <input
                    id="title-input{{ i }}"
                    class="form-control form-control-flush bg-white rounded"
                    placeholder="Enter your title"
                    *ngIf="result.writing != 'title' && result.writing != 'category'"
                    [(ngModel)]="result.value"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="card-footer border-0 p-0">
    <div class="actions-area">
      <div class="d-flex justify-content-between pb-5">
        <a class="custom-title-button my-4 fake-link align-self-start bg-primary bg-opacity-0 bg-hover-opacity-10 py-1 px-2 rounded" (click)="writeYourOwn()">Write your own instead</a>
        <a class="custom-title-button text-danger my-4 fake-link align-self-start bg-danger bg-opacity-0 bg-hover-opacity-10 py-1 px-2 rounded" (click)="resetTheProcess()">Don't like results? 👎</a>
      </div>
      <div class="d-flex justify-content-between">
        <button (click)="resetTheProcess()" class="btn btn-lg btn-light d-flex flex-center me-3">Back</button>
        <button *ngIf="componentData.selectedResultIndex != null" class="btn btn-primary" (click)="onSubmit()">Next</button>
        <button *ngIf="componentData.selectedResultIndex == null" disabled class="btn btn-primary">Select a title to proceed</button>
      </div>
    </div>
  </div>
</div>
<!-- Thinking -->
<div *ngIf="componentData.currentIdeationStep == currentIdeationStepEnum.thinking || !!componentData.localGeneratorData.resultsSync || componentData.localGeneratorData.generating" class="think-ai position-absolute d-flex flex-center no-result" [ngClass]="{ 'yes-results': !!componentData.results?.length }">
  <app-ai-thinking-loader [type]="animatedLoaderType.ai_loader"></app-ai-thinking-loader>
</div>
<!-- Thinking -->
